module.exports = __webpack_public_path__ + "static/media/bgi_talentx_app.c6f3bb20.jpg";